import React, { useState, useEffect } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import { get_all_registries, get_registry_details } from "../../../../Controllers/Registry";
import toast from "react-hot-toast";
import Loadercomponent from "../../../../Componets/Loader";
import moment from "moment";
import { Button, Collapse } from "antd";
import {
  ArrowLeftOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import tables from "../../../../Data/Tables/Billings/Sessions/tables";
import headers from "../../../../Data/Tables/Billings/Sessions/headers";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";
const { Panel } = Collapse;

const RegistrySessions = ({ onBack }) => {
  const [loader, setLoader] = useState(false);
  const [registries, setRegistries] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [previousPage, setPreviousPage] = useState(1);
  const [isSearching, setIsSearching] = useState(false);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const [header, setHeader] = useState(headers);

  useEffect(() => {
    fetchData();
  }, []);

  const formdata = (data) => {
    if (data?.search && !isSearching) {
      setPreviousPage(pagination.currentPage);
      setIsSearching(true);
    }

    if (!data?.search && isSearching) {
      setIsSearching(false);
      fetchData({
        ...data,
        currentPage: previousPage,
        totalCount: pagination?.totalCount,
        totalPages: pagination?.totalPages,
      });
      return;
    }

    let page = data?.search ? 1 : pagination?.currentPage;

    fetchData({
      ...data,
      page: page,
    });
  };

  const paginationdata = (data) => {
    let headerdata = {};
    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      search: headerdata?.search,
      start_date: headerdata?.date?.start,
      end_date: headerdata?.date?.end,
      page: data.currentPage,
      limit: 10,
    });
  };

  const fetchData = async (params = {}) => {
    try {
      setLoader(true);

      const data = {
        search: params.search || "",
        start_date:
          params.start_date ||
          moment().subtract(7, "days").format("YYYY-MM-DD"),
        end_date: params.end_date || moment().format("YYYY-MM-DD"),
        page: params.page || 1,
        limit: params.limit || 10,
      };

      const response = await get_all_registries(data);

      const iddata = {
        id: "690838da8bc77ce3d2bb0ae6"
      }

      const registry_details = await get_registry_details(iddata);


      if (response?.status) {
        setRegistries(response.data.registries || []);
        setPagination({
          currentPage: response.data.currentPage,
          totalCount: response.data.totalCount,
          totalPages: response.data.totalPages,
        });

        setLoader(false);
      } else {
        toast.error(response?.message || "Failed to fetch registries");
        setLoader(false);
      }
    } catch (error) {
      toast.error(error.message);
      setLoader(false);
    }
  };

  const toggleRowExpansion = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const prepareTableData = () => {
    return registries.map((registry) => {
      const totalCashIn =
        registry.cashIn?.reduce((sum, item) => sum + (item.amount || 0), 0) ||
        0;
      const totalCashOut =
        registry.cashOut?.reduce((sum, item) => sum + (item.amount || 0), 0) ||
        0;

      return {
        key: registry._id,
        path: `/app/billing/session/view/${registry?._id}`,
        Date: <DateTimeBadge date={registry?.date} />,
        "Opening Balance": `${registry.openingBalance?.toFixed(3)}`,
        "Closing Balance": `${registry.closingBalance?.toFixed(3)}`,
        "Total Sales": `${registry.totalSales?.toFixed(3)}`,
        "Cash In": `${totalCashIn.toFixed(3)}`,
        "Cash Out": `${totalCashOut.toFixed(3)}`,
        Expenses: `${registry.expenses ? registry?.expenses?.toFixed(3) : "-"}`,
        "Cash Difference": `${registry.cashDifference?.toFixed(3)}`,
        "Counted Cash": `${registry.countedCash?.toFixed(3)}`,
        "Total Invoices": registry.totalInvoices || 0,
        Status: registry.isOpen ? (
          <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
            Open
          </span>
        ) : (
          <span className="bg-blue-100 text-blue-600 text-sm px-2 py-1 rounded-lg">
            Closed
          </span>
        ),
      };
    });
  };

  const renderCashInOutDetails = (registry) => {
    return (
      <div className="p-4 bg-gray-50 rounded-lg">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <h4 className="font-semibold mb-2">Cash In Details</h4>
            {registry.cashIn && registry.cashIn.length > 0 ? (
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border p-2 text-left">Description</th>
                    <th className="border p-2 text-right">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {registry.cashIn.map((item, index) => (
                    <tr key={index}>
                      <td className="border p-2">
                        {item.description || "N/A"}
                      </td>
                      <td className="border p-2 text-right">
                        {item.amount?.toFixed(3)}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-50 font-semibold">
                    <td className="border p-2 text-right">Total:</td>
                    <td className="border p-2 text-right">
                      {registry.cashIn
                        .reduce((sum, item) => sum + (item.amount || 0), 0)
                        .toFixed(3)}
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : (
              <p className="text-gray-500">No cash in transactions</p>
            )}
          </div>

          <div>
            <h4 className="font-semibold mb-2">Cash Out Details</h4>
            {registry.cashOut && registry.cashOut.length > 0 ? (
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border p-2 text-left">Description</th>
                    <th className="border p-2 text-right">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {registry.cashOut.map((item, index) => (
                    <tr key={index}>
                      <td className="border p-2">
                        {item.description || "N/A"}
                      </td>
                      <td className="border p-2 text-right">
                        {item.amount?.toFixed(3)}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-50 font-semibold">
                    <td className="border p-2 text-right">Total:</td>
                    <td className="border p-2 text-right">
                      {registry.cashOut
                        .reduce((sum, item) => sum + (item.amount || 0), 0)
                        .toFixed(3)}
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : (
              <p className="text-gray-500">No cash out transactions</p>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h4 className="font-semibold mb-2">Additional Information</h4>
            <p>
              <strong>Notes:</strong> {registry.notes || "No notes"}
            </p>
            <p>
              <strong>Created By:</strong> {registry.createdBy || "Unknown"}
            </p>
            <p>
              <strong>Total Payments:</strong>{" "}
              {registry.totalPayments?.toFixed(3) || "0.000"}
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2">Session Summary</h4>
            <p>
              <strong>Opening Balance:</strong>{" "}
              {registry.openingBalance?.toFixed(3) || "0.000"}
            </p>
            <p>
              <strong>Total Sales:</strong>{" "}
              {registry.totalSales?.toFixed(3) || "0.000"}
            </p>
            <p>
              <strong>Cash In:</strong>{" "}
              {registry.cashIn
                ?.reduce((sum, item) => sum + (item.amount || 0), 0)
                .toFixed(3) || "0.000"}
            </p>
            <p>
              <strong>Cash Out:</strong>{" "}
              {registry.cashOut
                ?.reduce((sum, item) => sum + (item.amount || 0), 0)
                .toFixed(3) || "0.000"}
            </p>
            <p>
              <strong>Expected Cash:</strong>{" "}
              {(
                registry.openingBalance +
                registry.totalSales +
                registry.cashIn?.reduce(
                  (sum, item) => sum + (item.amount || 0),
                  0
                ) -
                registry.cashOut?.reduce(
                  (sum, item) => sum + (item.amount || 0),
                  0
                )
              ).toFixed(3)}
            </p>
            <p>
              <strong>Counted Cash:</strong>{" "}
              {registry.countedCash?.toFixed(3) || "0.000"}
            </p>
            <p>
              <strong>Difference: </strong>
              <span
                className={
                  registry.cashDifference >= 0
                    ? "text-green-600"
                    : "text-red-600"
                }
              >
                {registry.cashDifference?.toFixed(3) || "0.000"}
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>

        <Table
          head={tables}
          body={prepareTableData()}
          pagination={pagination}
          paginationdata={paginationdata}
        />

        {registries.map(
          (registry) =>
            expandedRows[registry._id] && (
              <div key={registry._id} className="mt-4 mb-6">
                {renderCashInOutDetails(registry)}
              </div>
            )
        )}
      </Loadercomponent>
    </Header>
  );
};

export default RegistrySessions;
